
<div>
  <p>{{ (message || 'common/messages/delete/message') | translate }}</p>
</div>

<div class="modal-footer">
  <button
    type="button"
    [class]="'btn ' + (submit_color ? submit_color : 'btn-danger')"
    (click)="close('yes')"
  >
    {{ (confirmLabel || 'common/buttons/yes') | translate }}
  </button>
  <button type="button" class="btn btn-secondary" (click)="close('no')">
    {{ (cancelLabel || 'common/buttons/no') | translate }}
  </button>
</div>
